<template>
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9 15H15M12.5 6.5L4 15H1V12L9.5 3.5M12.5 6.5L14.6982 4.39329C15.1006 3.99086 15.1006 3.33839 14.6982 2.93596L13.064 1.30182C12.6616 0.899392 12.0091 0.899392 11.6067 1.30182L9.5 3.5M12.5 6.5L9.5 3.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
</template>